import BenchlingConfig from 'BenchlingConfig';
import {pluralize} from 'BenchlingUtil';

// Admin facing name for ModelTypeConstants.SCHEMA_INTERFACE

// Keep in sync with benchling/schemas/schema_interfaces/v2/domain/lib/constants.py
export const SYSTEM_CATEGORY_EXTERNAL_NAME = 'System Category';

export function schemaFieldsetName(): string {
  return BenchlingConfig.SCHEMAS_RENAME_INTERFACE_TO_FIELDSET_AND_CATEGORY ? 'fieldset' : 'schema interface';
}

export function customSchemaFieldsetName(): string {
  return `Custom ${schemaFieldsetName()}`;
}

export function schemaFieldsetNamePluralized(): string {
  return pluralize(2, schemaFieldsetName());
}
